import { Box, Button, Modal } from "@mui/material"
import { useGetGroupsQuery } from "../groups/groupsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { useImportTasksFromGroupMutation } from "./taskBasesApiSlice"
import { useGetCoursesQuery } from "../courses/coursesApiSlice"
import { useGetTasksQuery } from "../tasks/tasksApiSlice"

const GroupToTaskBaseImporter = () => {
    
    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })
    const { tasks } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            tasks: data?.ids.map(id => data?.entities[id])
        }),
    })

    const [importerEvent, {isSuccess, data}] = useImportTasksFromGroupMutation()
    const [group, setGroup] = useState("")
    const [course, setCourse] = useState("")
    const [taskId, setTaskId] = useState("")
    const navigate = useNavigate()
    const {taskBaseId, groupId, type} = useParams()
    useEffect(()=>{
        if(isSuccess){
            navigate(`/${type}/${group}/task-bases/`)
        }

    },[isSuccess])
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        navigate(`/${type}/${groupId}/task-bases/`)
      };
    const handleImportClick = () => {
        if(!group || !course) {
            alert("please select group and course")
            return
        }
        importerEvent({course, group, taskId})
       
      };
    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })
    if(!courses || !groups || !tasks) return <h1>Loading</h1>
    const filteredTasks = group? tasks.filter(t=>t.group === group) : []
  return (


    <Modal
    open={true}
    onClose={handleClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
  >
    <Box sx={{ ...style, width: 400 }}>
        <div>
    <label className="form__label form__checkbox-container" htmlFor="group1">
                    בחר קבוצת מקור, כל המשימות של אותה הקבוצה יועתקו:</label>
                <select
                    id="group1"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>{setGroup(e.target.value); setTaskId("")}}
                >
                    <option value="">---choose group---</option>
                    {options}
                </select>
                </div>
        <div>
    <label className="form__label form__checkbox-container" htmlFor="course1">
                    בחר קורס:</label>
                <select
                    id="course1"
                    name="course"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={course}
                    onChange={(e)=>setCourse(e.target.value)}
                >
                  <option value="">---בחר קורס ---</option>
                   {courses.map((c)=>{
                    return <option key={c._id} value={c._id}>{c.name}</option>
                   })}
                </select>
                </div>
        <div>
    <label className="form__label form__checkbox-container" htmlFor="task1">
                   משימה בודדת</label>
                <select
                    disabled={!group}
                    id="task1"
                    name="task"
                    className={`form__input `}
                    value={taskId}
                    onChange={(e)=>setTaskId(e.target.value)}
                >
                  <option value="">---בחר משימה בודדת (אופציונאלי) ---</option>
                   {filteredTasks.map((t)=>{
                    return <option key={t._id} value={t._id}>{t.title}</option>
                   })}
                </select>
                </div>
                <div className="buttons-pan">
                <Button color="error" variant="contained" onClick={handleClose} >Close</Button>
                <Button variant="contained" onClick={handleImportClick} >ייבוא</Button>
              
                </div>
               
      
    </Box>
  </Modal>
  

  
  )
}

export default GroupToTaskBaseImporter